<div style="position: relative">
  <div *ngIf="loading || loadingButton" style="position: absolute; height: 100%; width: 100%"
    class="d-flex align-items-center justify-content-center">
    <div class="spinner-border text-primary" style="width: 4rem; height: 4rem" role="status">
      <span class="visually-hidden">Carregando mapa...</span>
    </div>
  </div>
  <div *ngIf="asImage&&imagemSrc" style="width: 100%; height: 100%">
    <img [src]="imagemSrc" alt="Mapa" [id]="id+'-imagem'">
  </div>
  <ng-container *ngIf="(asImage&&imagemSrc)||!asImage">
    <ng-content></ng-content>
  </ng-container>
  <div [style]="asImage?'display: none':''" *ngIf="!asImage||!imagemSrc">
    <div [ngSwitch]="tipoMapa" style="width: 100%; height: 100%">
      <div *ngIf="(microrregiao || geocodigosVisiveis?.length) && !delimitarRegioes;else mapaInteiro">
        <svg #svgRef [id]="id" style="max-height: 400px; width: 100%" [attr.viewBox]="calculateMicrorregiaoViewBox()"
          xmlns="http://www.w3.org/2000/svg">
          <ng-container *ngTemplateOutlet="municipiosDesagrupados"></ng-container>
        </svg>
      </div>
      <ng-template #mapaInteiro>

        <div *ngIf="delimitarRegioes">
          <seira-paraiba-dividida-por-regiao-component>
            <ng-container *ngTemplateOutlet="paraibaPorRegiao"></ng-container>
          </seira-paraiba-dividida-por-regiao-component>
        </div>
        <div *ngIf="!delimitarRegioes">
          <seira-municipios-container *ngSwitchCase="'municipios'" [id]="id">
            <ng-container *ngTemplateOutlet="municipios"></ng-container>
          </seira-municipios-container>

          <seira-municipios-container *ngSwitchCase="'estatico'" [id]="id">
            <ng-container *ngTemplateOutlet="municipiosEstaticos"></ng-container>
          </seira-municipios-container>
        </div>
        <seira-precipitacao-container *ngSwitchCase="'precipitacao'" [id]="id" [visibilidadeLegenda]="visibilidadeLegenda" >
          <ng-container *ngTemplateOutlet="municipios"></ng-container>
        </seira-precipitacao-container>
      </ng-template>
    </div>
  </div>
</div>

<div [style]="asImage?'display: none':''">
  <ng-template #municipios>
    <ng-container *ngIf="informacoes.length; else municipiosDesagrupados">
      <svg:g #mapa xmlns:svg="http://www.w3.org/2000/svg" (mouseenter)="onMouseEnterMap()"
        (mouseleave)="onMouseLeaveMap()">
        <ng-container *ngFor="let mesorregiao of informacoesMesorregioes">
          <svg:g *ngIf="localizacaoMesorregioes[mesorregiao.nomeMesorregiao]" [id]="mesorregiao.nomeMesorregiao">
            <ng-container *ngFor="let municipioPath of municipioPaths" xmlns:svg="http://www.w3.org/2000/svg">
              <ng-container *ngIf="mesorregiao.geocodigos.includes(+municipioPath.geocodigo)">
                <ng-container *ngTemplateOutlet="municipio; context: { municipioPath: municipioPath }"></ng-container>
              </ng-container>
            </ng-container>
            <svg:image *ngIf="eventos?.length" [attr.href]="obterHrefTipoEvento(mesorregiao.nomeMesorregiao)" height="35000" width="35000"
              [attr.x]="localizacaoMesorregioes[mesorregiao.nomeMesorregiao].x"
              [attr.y]="localizacaoMesorregioes[mesorregiao.nomeMesorregiao].y" [class.fade-out]="isHovered"
              [class.fade-in]="!isHovered"></svg:image>
          </svg:g>
        </ng-container>
      </svg:g>
    </ng-container>
  </ng-template>

  <ng-template #paraibaPorRegiao>
    <ng-container *ngIf="informacoes.length; else municipiosDesagrupados">
      <svg:g #mapa xmlns:svg="http://www.w3.org/2000/svg" (mouseenter)="onMouseEnterMap()"
        (mouseleave)="onMouseLeaveMap()">
        <ng-container *ngFor="let info of informacoesRegioes">
          <svg:g *ngIf="localizacaoRegioes[info.nomeRegiao]" [id]="info.nomeRegiao">
            <ng-container *ngFor="let municipioPath of municipioPaths" xmlns:svg="http://www.w3.org/2000/svg">
              <ng-container *ngIf="info.geocodigos.includes(+municipioPath.geocodigo)">
                <ng-container *ngTemplateOutlet="municipio; context: { municipioPath: municipioPath }"></ng-container>
              </ng-container>
            </ng-container>
            <svg:image *ngIf="eventos?.length" [attr.href]="obterHrefTipoEvento(info.nomeRegiao, 'nomeRegiao')" height="35000"
              width="35000" [attr.x]="localizacaoRegioes[info.nomeRegiao].x"
              [attr.y]="localizacaoRegioes[info.nomeRegiao].y" [class.fade-out]="isHovered"
              [class.fade-in]="!isHovered"></svg:image>
          </svg:g>
        </ng-container>
      </svg:g>
    </ng-container>
  </ng-template>

  <ng-template #municipiosEstaticos>
    <ng-container *ngFor="let municipioPath of municipioPaths" xmlns:svg="http://www.w3.org/2000/svg">
      <svg:g [id]="id+'_'+municipioPath.geocodigo" xmlns:svg="http://www.w3.org/2000/svg">
        <svg:g>
          <svg:path #path [textContent]="municipioPath.name" [attr.data-nome]="municipioPath.name"
            [id]="id+'_'+municipioPath.geocodigo" [attr.d]="municipioPath.d" fill-rule="evenodd" clip-rule="evenodd"
            fill="none"
            style="cursor:pointer;stroke:#646464;stroke-width:92.1038;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
        </svg:g>
      </svg:g>
    </ng-container>
  </ng-template>

  <ng-template #municipiosDesagrupados>
    <ng-container *ngFor="let municipioPath of municipioPaths" xmlns:svg="http://www.w3.org/2000/svg">
      <ng-container *ngTemplateOutlet="municipio; context: {municipioPath: municipioPath}"></ng-container>
    </ng-container>
  </ng-template>

  <ng-template #municipio let-municipioPath="municipioPath" let-nomeMunicipio="municipioPath.name.split('-')[0]">
    <svg:g #tooltip="bs-tooltip" [id]="id+'_'+municipioPath.geocodigo" [tooltip]="locationTooltip"
      [attr.data-tooltipId]="tooltip.tooltipId" triggers="" container="#map-container" containerClass="location-tooltip"
      xmlns:svg="http://www.w3.org/2000/svg">
      <svg:g [tooltip]="locationTooltip" container="#map-container" containerClass="location-tooltip">
        <svg:path #path #popover="bs-popover" [textContent]="municipioPath.name" [popover]="popoverTemplate"
          [attr.data-nome]="municipioPath.name" [attr.data-popoverId]="popover.popoverId"
          [popoverContext]="popoverContext" [id]="id+'_'+municipioPath.geocodigo" [outsideClick]="true"
          (mouseenter)="onMouseEnter($event)" (mouseleave)="onMouseLeave($event)" (click)="onClick($event, popover)"
          (onHidden)="onPopoverHidden()" [attr.d]="municipioPath.d" triggers="" container="#map-container"
          fill-rule="evenodd" clip-rule="evenodd" fill="none"
          style="cursor:pointer;stroke:#000000;stroke-width:92.1038;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" />
      </svg:g>
    </svg:g>

    <ng-template #locationTooltip>
      <i class="ph-map-pin"></i> {{ nomeMunicipio }}
    </ng-template>
  </ng-template>
</div>
